<template>
  <div class="m-card-wrapper">
    <div class="m-card" :class="{ 'm-card__flair-new': flair === 'new' }">
      <div class="m-card__body">
        <div class="m-card__body-head">
          <h2>{{ $t('components.cardaction.new') }}</h2>
        </div>
        <div class="m-card__body-content">
          <span>{{ $t('components.cardaction.addBooth') }}</span>
        </div>
        <div class="m-card__body-footer">
          <a href="#">
            <img src="../assets/images/icons/white_plus.svg" alt="" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardFair',
  props: {
    flair: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/variables.scss';
$color-main: #4187ba;

@mixin setBgColorAndHover($color) {
  background-color: $color;

  &:hover {
    background-color: darken($color, 10%);
    cursor: pointer;
  }
}

.m-card {
  @include setBgColorAndHover($color-main);
  height: 260px;
  width: 294px;
  border-radius: 0;
  color: #fff;
  transition: all .2s ease-in-out;

  &:hover {
    transform: scale(1.1);
  }

  &__flair-new {
    @include setBgColorAndHover($brand-secondary);
    border-radius: 50%;
    padding: 10%;
  }

  @media (max-width: 770px) {
    width: 100%;
    min-width: 294px;
  }

  &__body {
    padding: 24px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;

    h2 {
      font-family: Arial, "Helvetica Neue", Helvetica, sans-serif;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.43;
      letter-spacing: 0.6px;
      color: #ffffff;
      margin-bottom: 0;
    }

    &-content {
      font-size: $card-text-font-size;
      font-weight: 300;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.67;
      letter-spacing: 0.6px;
      flex-grow: 1;
    }

    &-footer {
      display: block;
      text-align: right;
    }
  }
}

.m-card-wrapper {
  @media (max-width: 770px) {
    width: 100%;
    min-width: 294px;
  }
}
</style>
